import React from 'react';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import styles from './sankeyChart.module.scss';

const EmptyStateChart: React.FC = () => {
  return (
    <div className={styles.chartWrapper}>
      <div className={styles.totalWrapper}>
        <GenerateIcon iconName={ICONS.coins.name} className={styles.icon} />
        <span className={styles.header}>Total Cost</span>
        <span className={styles.value}>0</span>
      </div>
      <span className={styles.noDataWrapper}>No Data</span>
      <span className={styles.noDataWrapper}>No Data</span>
    </div>
  );
};

export default EmptyStateChart;
